import { useEffect } from "react";
import { UiAction, UiPage, useRegisterUserActionMutation } from "~/operations";
import { useScope } from "~/hooks/useScope";
import * as Sentry from "@sentry/react";

export interface UseReportViewedParams {
  page: UiPage;
  pageLoaded: boolean;
  orgMrn?: string;
  spaceMrn?: string;
  assetMrn?: string;
  tab?: string;
}

export function useReportViewed(params: UseReportViewedParams) {
  const [registerUserAction, registerUserActionResult] =
    useRegisterUserActionMutation();

  const { organizationScope, spaceScope } = useScope();

  const { page, pageLoaded } = params;
  const orgMrn = params.orgMrn ?? organizationScope?.mrn ?? "unknown";
  const spaceMrn = params.spaceMrn ?? spaceScope?.mrn ?? "unknown";
  const tab = params.tab ?? "unknown";

  // Send user action mutation when page data has loaded and mrns change
  useEffect(() => {
    if (pageLoaded) {
      registerUserAction({
        variables: {
          input: {
            action: UiAction.View,
            page: page,
            scopeMrn: spaceMrn || orgMrn,
            details: tab,
          },
        },
        onError: (error) => {
          Sentry.captureException(
            new Error(`RegisterUserAction failed: ${error.message}`),
            {
              contexts: {
                RegisterUserAction: {
                  page,
                  action: UiAction.View,
                  scopeMrn: spaceMrn || orgMrn,
                  details: tab,
                },
              },
            },
          );
        },
      });
    }
  }, [pageLoaded, orgMrn, spaceMrn, tab]);

  return registerUserActionResult;
}
